import { useState } from 'react';
import type { Evenement } from '@qc/db';
import { Aanmeldscherm } from './auth/Aanmeldscherm.js';
import { InlogScherm } from './auth/InlogScherm.js';
import { NieuwWachtwoordScherm } from './auth/NieuwWachtwoordScherm.js';
import { useSessie } from './auth/useSessie.js';
import { EvenementenScherm } from './evenementen/EvenementenScherm.js';
import { EvenementScherm } from './evenement/EvenementScherm.js';

/**
 * Het dashboard van de organisator.
 *
 * Drie stappen die hij helemaal zelf doorloopt: inloggen of aanmelden, zijn
 * bedrijfsgegevens invullen, en dan zijn evenementen. Wij hoeven er niets voor
 * te doen.
 */
export function App() {
  const sessie = useSessie();
  const [open, setOpen] = useState<Evenement | null>(null);

  if (sessie.status === 'laden') {
    return <p className="p-8 text-xl text-tekst-zacht">Bezig met laden…</p>;
  }

  if (sessie.status === 'uitgelogd') {
    return <InlogScherm onKlaar={() => void sessie.ververs()} />;
  }

  // Via de link uit de herstelmail is hij al ingelogd; eerst het wachtwoord kiezen.
  if (sessie.herstel) {
    return (
      <NieuwWachtwoordScherm
        email={sessie.email ?? ''}
        onKlaar={() => {
          window.history.replaceState(null, '', window.location.pathname);
          sessie.herstelKlaar();
          void sessie.ververs();
        }}
        onAnnuleren={() => void sessie.logUit()}
      />
    );
  }

  if (sessie.status === 'zonder_profiel') {
    return (
      <Aanmeldscherm
        gebruikerId={sessie.gebruikerId ?? ''}
        email={sessie.email ?? ''}
        onKlaar={sessie.ververs}
        onUitloggen={sessie.logUit}
      />
    );
  }

  if (open !== null) {
    return (
      <EvenementScherm
        evenement={open}
        isAdmin={sessie.profiel?.rol === 'admin'}
        onTerug={() => setOpen(null)}
      />
    );
  }

  return (
    <EvenementenScherm
      organisator={sessie.organisator}
      onOpen={setOpen}
      onUitloggen={sessie.logUit}
    />
  );
}
